// extracted by mini-css-extract-plugin
export default {"canvas":"Snowflakes_canvas__IE7ZE"};